<template>
  <TableLayout>
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="关键字" prop="name">
        <el-input type="text" placeholder="请输入关键字" v-model="searchForm.key"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li><el-button type="primary" icon="el-icon-plus" @click="$refs.operaConfigDrawer.open('新建系统配置')">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete">删除</el-button></li>
      </ul>
      <el-table
          v-loading="isWorking.search"
          :data="tableData.list"
          stripe
          @sort-change="handleSortChange"
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="配置项" min-width="100px"></el-table-column>
        <el-table-column prop="key" label="键" min-width="150px"></el-table-column>
        <el-table-column prop="value" label="值" min-width="140px">
          <ColumnDetail slot-scope="{ row }" :content="row.value"/>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="200px"></el-table-column>
        <el-table-column prop="createUserInfo.realname" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
        <el-table-column prop="updateUserInfo.realname" label="更新人" min-width="100px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="140px"></el-table-column>
        <el-table-column
          label="操作"
          min-width="200"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaConfigDrawer.open('编辑系统配置', row)" icon="el-icon-edit">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 编辑 -->
    <OperaConfigDrawer ref="operaConfigDrawer" @success="handlePageChange(tableData.pagination.pageIndex)"/>
  </TableLayout>
</template>

<script>
import TableLayout from '@/layouts/TableLayout'
import BaseTable from '@/components/base/BaseTable'
import OperaConfigDrawer from '@/components/system/config/OperaConfigDrawer'
import ColumnDetail from '../../components/common/ColumnDetail'
export default {
  name: 'config',
  extends: BaseTable,
  components: { ColumnDetail, OperaConfigDrawer, TableLayout },
  data () {
    return {
      searchForm: {
        key: '' // 关键字
      }
    }
  },
  methods: {},
  created () {
    this.config({
      module: '系统配置',
      api: '/system/config',
      'field.id': 'id',
      'field.main': 'key'
    })
    this.search()
  }
}
</script>

<style scoped lang="scss">

</style>
